import React from "react";

const NoContentView = props => {
	return (
		<div>No content to be displayed.</div>
	);
};

export { NoContentView };